module.exports = __webpack_public_path__ + "604b65f7fad895fd793a48c010bf7b64.png";